import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';
import { CssBaseline } from '@mui/material'; // Ensure this is imported
import { createGlobalStyle } from 'styled-components'; // NEW: Import createGlobalStyle

// NEW: Define a global style to target html, body, and #root
const GlobalStyle = createGlobalStyle`
  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden; /* Prevent global scrollbar */
  }

  body {
    background-color: transparent !important; /* Ensure no default body background */
  }
`;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* MUI's CSS reset */}
      <GlobalStyle /> {/* Your custom global styles */}
      <App />
    </ThemeProvider>
  </React.StrictMode>
);